import React from 'react';

import { observer } from 'mobx-react-lite';

import { TableFooter, roundInfoStore, userCountStore, betStore } from '@pascal/pascal-core';
import { totalBetStore } from '../../store/totalBetStore';

// import { winningAmountStore } from '../../store/winningAmountStore';

const FooterWr = observer(() => {
  const { roundId } = roundInfoStore;
  const { usersCount } = userCountStore;
  const { repliedBetData } = betStore;
  const { totalBet } = totalBetStore;

  // const { lastWinAmount } = winningAmountStore;

  return !repliedBetData ? (
    <TableFooter
      // lastWin={lastWinAmount}
      roundId={`${roundId}`}
      usersCount={usersCount}
      totalBet={totalBet}
    />
  ) : (
    <></>
  );
});

export default FooterWr;
